export default function assert(condition, message) {
  if (!condition) {
    throw new Error("Assertion failed. ".concat(message));
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/env/assert.js
// module id = 1632
// module chunks = 0